import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { formatArchiveDate } from '../lib/archiveFeeds';
import '../styles/common.css';
import './DevBlog.css';

const BLOG_URL = 'https://blog.koiro.me';
const POSTS_JSON_URL = 'https://blog.koiro.me/posts.json';

function DevBlog() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.email === 'calicorone@gmail.com';
  const { t } = useTranslation();

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchPosts = async () => {
      try {
        const res = await fetch(POSTS_JSON_URL);
        if (!res.ok || cancelled) return;
        const data = await res.json();
        if (!cancelled && Array.isArray(data)) setPosts(data);
      } catch {
        if (!cancelled) setPosts([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchPosts();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="devblog-skin">
      <main className="devblog-page">
        <header className="devblog-hero">
          <span className="devblog-kicker">{t('devblog.kicker')}</span>
          <h1 className="devblog-title">{t('devblog.title')}</h1>
          <p className="devblog-desc">{t('devblog.desc')}</p>
          {isAdmin && (
            <div className="devblog-hero-buttons">
              <button
                type="button"
                className="devblog-write-btn"
                onClick={() => navigate('/dev-blog/write-jekyll')}
              >
                {t('devblog.writeBtn')}
              </button>
            </div>
          )}
        </header>

        <section className="devblog-posts">
          <p className="devblog-section-label">{t('devblog.listLabel')}</p>

          {loading && <p className="devblog-loading">{t('devblog.loading')}</p>}

          {!loading && posts.length === 0 && (
            <div className="devblog-fallback">
              <p className="devblog-empty">{t('devblog.empty')}</p>
              <a
                href={BLOG_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="devblog-visit-btn"
              >
                {t('devblog.visitBtn')}
              </a>
            </div>
          )}

          {!loading && posts.length > 0 && (
            <>
              <ul className="devblog-feed-list">
                {posts.map((post, i) => (
                  <li key={post.url || i} className="devblog-feed-item">
                    <a
                      href={post.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="devblog-feed-link"
                    >
                      <span className="devblog-feed-date">{formatArchiveDate(post.date)}</span>
                      <span className="devblog-feed-title">{post.title}</span>
                    </a>
                  </li>
                ))}
              </ul>
              <a
                href={BLOG_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="devblog-visit-link"
              >
                {t('devblog.visitLink')}
              </a>
            </>
          )}
        </section>
      </main>
    </div>
  );
}

export default DevBlog;
